/**
 * yojo-catalog-menu.js — dismissal behaviour for the desktop catalogue menu.
 *
 * The menu is a native <details data-js-catalog-menu><summary>, which is
 * deliberate: it opens, closes and toggles by keyboard with zero JavaScript, so
 * the catalogue stays reachable if this file fails to load. Native <details>
 * does NOT, however, close on Escape or on an outside click — and the search
 * overlay in the same header does both. A keyboard user could open the
 * catalogue and have no way to dismiss it without tabbing through all 17 links
 * or re-activating the summary.
 *
 * Found by the 2026-08-01 nav-taxonomy audit: `data-js-catalog-menu` was a hook
 * with no JavaScript attached to it anywhere in the theme.
 *
 * This adds only dismissal. Opening stays native. Everything is delegated off
 * document, so it survives section re-render and covers both header instances
 * (static + sticky) without knowing about them.
 */
(function () {
  'use strict';

  var SEL = 'details[data-js-catalog-menu]';

  function openMenus() {
    return Array.prototype.filter.call(document.querySelectorAll(SEL), function (d) {
      return d.open;
    });
  }

  /** Close and, when the user got here by keyboard, put focus back on the summary. */
  function close(details, restoreFocus) {
    if (!details || !details.open) return;
    details.open = false;
    if (restoreFocus) {
      var summary = details.querySelector('summary');
      if (summary && typeof summary.focus === 'function') summary.focus();
    }
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    var open = openMenus();
    if (!open.length) return;
    // Don't fight the search overlay: it owns Escape while it is open.
    var overlay = document.getElementById('yojo-search-overlay');
    if (overlay && overlay.getAttribute('aria-hidden') === 'false') return;
    open.forEach(function (d) {
      close(d, d.contains(document.activeElement));
    });
  });

  document.addEventListener('click', function (e) {
    var open = openMenus();
    if (!open.length) return;
    open.forEach(function (d) {
      if (!d.contains(e.target)) close(d, false);
    });
  });

  /**
   * Tabbing past the last link should also dismiss, otherwise focus lands on
   * page content behind a panel that is still visually open.
   */
  document.addEventListener('focusin', function (e) {
    openMenus().forEach(function (d) {
      if (!d.contains(e.target)) close(d, false);
    });
  });
})();
